/**
 * Function to formate timer
 * @returns - time in format hh:mm:ss or mm:ss
 * @example - formattedCounter  = formatTimer(number);
 */
export const formatTimer = (count: number) => {
  const getSeconds = `0${count % 60}`.slice(-2);
  const minutes: number = parseInt(`${Math.floor(count / 60)}`);
  const getMinutes = `0${minutes % 60}`.slice(-2);
  const getHours = `0${Math.floor(count / 3600)}`.slice(-2);
  if (Number(getHours) > 0) return `${getHours}:${getMinutes}:${getSeconds}`;
  else return `${getMinutes}:${getSeconds}`;
};

/**
 * Function to formate time
 * @returns - time in format mm:ss or mm min or hh.mm hr
 * @example - formattedCounter  = formatTime(number);
 */
export const formatTime = (count: number) => {
  const getSeconds = `0${count % 60}`.slice(-2);
  const minutes = parseInt(`${Math.floor(count / 60)}`);
  const getMinutes = `0${minutes % 60}`.slice(-2);
  const getHours = `${Math.floor(count / 3600)}`;
  const getDays = `${Math.floor(+getHours / 24)}`;
  if (Number(getHours) >= 24) {
    if (Number(getDays) == 1) return `${getDays} day`;
    else return `${getDays} days`;
  }
  if (Number(getHours) >= 1) {
    if (Number(getMinutes) < 30) return `${getHours} hr`;
    else return `${getHours}.5 hr`;
  }
  if (Number(getMinutes) >= 5) return `${getMinutes} min`;
  else return `${getMinutes}:${getSeconds}`;
};
/**
 * Function to calculate current hold time for any call
 * @returns - time in seconds
 * @example - calculateHoldDuration("")
 */
export const getDurationInSeconds = (dateTime: Date): number => {
  return Math.ceil(
    (new Date().getTime() - new Date(dateTime).getTime()) / 1000
  );
};

/**
 * Function to calculate the current timzone offset in utc
 * @returns - time zone offset in utc format
 * @example - getUtcTimezoneOffset()
 */
export const getUtcTimezoneOffset = () => {
  const timeZoneOffset = new Date().getTimezoneOffset();

  const timeZoneOffsetInHours = new Date(Math.abs(timeZoneOffset) * 1000)
    .toISOString()
    .substring(14, 19);

  if (timeZoneOffset < 0) return timeZoneOffsetInHours;
  else return `-${timeZoneOffsetInHours}`;
};

/**
 * TODO: For now we are not considering this function for multilingual support
 * after getting confirmation from product will update the logic
 * get date and time format
 * @param date - date string
 * @returns - Required formatted date and time stamp.
 * @example - getDateAndTimeFormat("2022-05-23T06:26:13+00:00")
 */
export const getDateAndTimeFormat = (date: string): string => {
  const dateToFormat = new Date(date);
  const sMonth = String(dateToFormat.getMonth() + 1).padStart(2, '0');
  const sDay = String(dateToFormat.getDate()).padStart(2, '0');
  const sYear = dateToFormat.getFullYear();
  let sHour = dateToFormat.getHours();
  const sMinute = String(dateToFormat.getMinutes()).padStart(2, '0');
  let hourlyFormat = 'am';

  const iHourCheck = sHour;
  if (iHourCheck > 12) {
    hourlyFormat = 'pm';
    sHour = iHourCheck - 12;
  } else if (iHourCheck === 0) {
    sHour = 12;
  }
  const hours = String(sHour).padStart(2, '0');
  return (
    sMonth +
    '/' +
    sDay +
    '/' +
    sYear +
    ' at ' +
    hours +
    ':' +
    sMinute +
    ' ' +
    hourlyFormat
  );
};

/**
 * Function to check the Eternals environment
 * @returns - boolean value
 * @example - checkEnvironment()
 */
export const isEternalsEnv = () => {
  const currentURL = window.location.href;
  const baseUrls = [
    'https://d1s74gzjhz7gu0.cloudfront.net',
    'https://d1u959wi0vug3n.cloudfront.net',
    'http://localhost:4200', // comment this line to run CcfAcd at landing page on local for POC
  ];

  return baseUrls.some((baseUrl) => currentURL.startsWith(baseUrl));
};

/**
 * Function to get the AWS S3 configuration
 * AWS S3 configuration object.
 * Contains credentials and bucket information for AWS S3 access.
 */
export const awsS3Config = {
  accessKeyId: 'AKIAVFMUJ6SX7NP6G5FY',
  secretAccessKey: '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',
  s3Bucket:
    window.location.hostname === 'd1u959wi0vug3n.cloudfront.net'
      ? 'cxone-agent-html-demo-phase2'
      : 'cxone-agent-demo-app',
  region: 'us-west-2',
};